import { Model } from "pinia-orm";
import { DomainVersion, Competence, CompetenceDomain, DomainGroup } from "@/models";

export default class Domain extends Model {
  static entity = "domains";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      code: this.string(""),

      competences: this.belongsToMany(Competence, CompetenceDomain, "domainUuid", "competenceUuid"),
      isDisplayed: this.boolean(true),

      // Foreign keys
      domainGroupUuid: this.string(""),
      domainGroupData: this.belongsTo(DomainGroup, "domainGroupUuid"),
      domainVersionsList: this.hasMany(DomainVersion, "domainUuid"),
    };
  }
}
